import { toggleFilterMenu } from "./filter-helpers";

document.addEventListener("DOMContentLoaded", () => {
  [...document.querySelectorAll("[data-filter-button]")].forEach(
    (toggleButton) => {
      toggleButton.addEventListener("click", () => {
        toggleFilterMenu();
      });
    }
  );
});
